<div class="container-fluid">

    <app-head></app-head>

    <div class="row">
        <table>
            <tr>
                <td style="height: 12vh;">
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <div class="col w-100">
            <br>
            <div class="container-fluid">
                <nav class="breadcrumb bg-white">
                    <a class="breadcrumb-item" href="#">首頁</a>
                    <a class="breadcrumb-item">學潛水</a>
                    <a class="breadcrumb-item">減壓專長潛水員</a>
                </nav>
            </div>
            <br>
        </div>
    </div>

    <div class="row">
        <div class="col-xl">
        </div>
        <div class="col-xl-8">
            <h3 style="font-family:DFKai-sb;">減壓專長潛水員</h3>
            <!-- 課程介紹 -->
            <div>
                <br>
                <h3>課程介紹</h3>
                <hr>
                <table borderless="true" style="text-align: justify;">
                    <tr>
                        <td class="fs-6">
                            休閒潛水總是被減壓時間追著跑，電腦錶不小心進了減壓卻不知道怎麼辦？進了減壓害怕身體會受傷？
                            到底該怎麼安全的執行減壓呢？上完課程後，你將學會有計畫的進行一次減壓潛水，不小心進入減壓時如何操作，
                            與進減壓後但是氣源有限，我們如何判斷減壓的風險。讓我們未來讓潛水可以更加安全。
                        </td>
                    </tr>
                </table>
                <br>
                <table borderless="true" style="text-align: justify;">
                    <tr>
                        <td><img src="../../../assets/Image/Data/DECO.jpg" width="100%" /></td>
                    </tr>
                </table>
                <br>
                <table width="100%" style="text-align: justify;">
                    <tr class="fs-6">
                        <span class="Large Important">
                            報名條件：<br />
                            基本條件需年滿16歲、已擁有24次的潛水紀錄、已取得深潛專長(DD)與高氧專長(EAN40)。
                        </span>
                    </tr>
                </table>
            </div>
            <!-- 課程規劃 -->
            <div>
                <br>
                <h3>課程規劃</h3>
                <hr>

                <table mdbTable bordered="true" border="1" width="100%" style="text-align: justify;">
                    <tbody>
                        <tr align="center">
                            <td class="fs-6">&nbsp;</td>
                            <td class="fs-6" style="font-weight:bold;">時 間</td>
                            <td class="fs-6" style="font-weight:bold;">課 程 內 容</td>
                            <td class="fs-6" style="font-weight:bold;">上課地點</td>
                        </tr>
                        <tr align="center">
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle">學 科</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">6hr</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">潛水生理學、減壓設備、減壓理論、執行減壓</td>
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle;">iDiving  教 室</td>
                        </tr>
                        <tr align="center">
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle">平靜水域</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">1次</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">裝備組裝與調整，安全檢查，交換階段氣瓶。</td>
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle;">平靜水域</td>
                        </tr>
                        <tr align="center">
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle">海洋實習</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">3次</td>
                            <td class="fs-6" valign="middle" style="font-weight:bold;vertical-align:middle;">模擬減壓，計算耗氣量，減壓潛水</td>
                            <td class="fs-6" style="font-weight:bold;vertical-align:middle;">東北角或移地訓練</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 開課日期 -->
            <div>
                <br>
                <h3>開課日期</h3>
                <hr>
                <img src="../../../assets/Image/Data/DECO_Schedule.png" width="98%" />
            </div>
            <!-- 超值學費 -->
            <div>
                <br>
                <h3>超值學費</h3>
                <hr>
                <table width="100%" style="text-align: justify;">
                    <tr>
                        <td class="fs-6" style="color: green;">定價：15,000元</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">1.現金優惠：折扣 300元</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">2.多人同行優惠：</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">兩人同行，折扣 1,000 元。</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">三人同行，折扣 1,500 元。</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">四人同行，折扣 2,000 元。</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="color: red;">折扣優惠：現金優惠可與多人優惠併用</td>
                    </tr>
                </table>
                <br>
                <table width="100%" style="text-align: justify;" border="0" cellpadding="0" cellspacing="0">
                    <tr>
                        <td class="fs-6" style="vertical-align:text-top;" nowrap>費用包含：</td>
                        <td class="fs-6">重裝租借（含兩組調節器、氣瓶綁帶、與BC）、線上教材、國際數位證照申請、教練費、海洋實習氣瓶(背掛瓶與階段氣瓶)、保險費。</td>
                    </tr>
                    <tr>
                        <td class="fs-6" style="vertical-align:text-top;">費用不含：</td>
                        <td class="fs-6">
                            輕裝租借、
                            <samp style="color: red;">技術潛水電腦錶</samp>
                            、移地海洋實習結訓之旅遊團費(交通食宿與出海船資)。
                        </td>
                    </tr>
                </table>
                <br>
            </div>
            <!-- 報名方式 -->
            <app-paymentmethod></app-paymentmethod>

        </div>
        <div class="col-xl">
        </div>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <app-foot></app-foot>

</div>